import "./App.css";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Work from "./components/work/Work";
import projects from "./db.json";
import { useState } from "react";

function App() {

  const [selectedCategory, setSelectedCategory] = useState('');
  
  const filteredProjects = selectedCategory
    ? projects.filter((project) => project.category === selectedCategory)
    : projects;

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  

  return (
    <div className="App">
      <Header />
      <div className="app">
        <h2 className="work-header">Work</h2>
        <select class="classic" value={selectedCategory} onChange={handleCategoryChange}>
          <option>Select Projects Category </option>
          <option value="freelance">freelance</option>
          <option value="open-source">open-source</option>
          <option value="personal">personal</option>
          <option value="work">Job</option>

        </select>
        <div className="one-work">
          {filteredProjects.map((project, index) => (
            <div className="work" key={index}>
              <Work
                id={project.id}
                name={project.name}
                description={project.description}
                url={project.url}
                github={project.github}
                builtWith={project.builtWith}
                image={project.image}
                solutions={project.solutions}
              />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
